import type {
  TransactionQueryParams,
  TransactionsListResponse,
  TransactionDetail,
} from '@/types/drawdown';
import { apiClient } from '@/utils/api-client';

// Helper function to build query string
function buildQueryString(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
}

export class TransactionService {
  /**
   * Get transactions with filtering and pagination
   */
  static async getTransactions(
    fundId: string,
    params: Omit<TransactionQueryParams, 'fund_id'> = {}
  ): Promise<TransactionsListResponse> {
    const queryString = buildQueryString(params);
    return apiClient.get<TransactionsListResponse>(
      `/funds/${fundId}/ledger/transactions?${queryString}`
    );
  }

  /**
   * Get a single transaction with its journal entries
   */
  static async getTransactionDetail(
    fundId: string,
    transactionId: string
  ): Promise<TransactionDetail> {
    return apiClient.get<TransactionDetail>(
      `/funds/${fundId}/ledger/transactions/${transactionId}`
    );
  }
}
